module.exports = __webpack_public_path__ + "static/media/male.b1f3a338.svg";